/* eslint-disable react-hooks/exhaustive-deps */

import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useMutation, useQuery} from "@apollo/react-hooks";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {CREATE_USER, GET_USER, UPDATE_USER} from "../../database/queries/userQueries";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import BackupOutlinedIcon from "@material-ui/icons/BackupOutlined";
import ClearIcon from "@material-ui/icons/Clear";
import {notify} from "../../utils/notify";
import usePersistentStore from "../../persistentStore";
import FormHelperText from "@material-ui/core/FormHelperText";
import {useHistory, useParams} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        '& .ReactTags__tagInputField': {
            paddingLeft: 5,
            paddingRight: 5,
        },
    },
    gridContainer: {
        overflow: 'auto',
        overflowY: 'scroll',
        padding: 20,
    },
    leftField: {
        paddingRight: 10
    },
    middleField: {
        paddingLeft: 10,
        paddingRight: 10
    },
    rightField: {
        paddingLeft: 10,
    },
    hidden: {
        display: 'none',
    },
    grow: {
        flexGrow: 1,
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
        marginRight: 10,
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
}));

const INITIAL_USER = {
    userId: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    userDescription: '',
    tags: []
};

const UserEdit = props => {
    const classes = useStyles();
    const [globalPersistentState, globalPersistentActions] = usePersistentStore();
    const [user, setUser] = useState({
        ...INITIAL_USER,
    }); // need this so we dont edit global user
    // const [userChanged, setUserChanged] = useState(false);
    const [errors, setErrors] = useState({});
    const history = useHistory();
    let {editId} = useParams();

    const {loading: getUserLoading, error: getUserError, data: getUserData} = useQuery(GET_USER, {
        skip: !editId || editId === 'new',
        variables: {userId: editId},
    });

    const [updateUser, {error: updateUserError}] = useMutation(UPDATE_USER, {
        variables: {
            changedUser: {
                userId: user.userId,
                firstName: user.firstName,
                lastName: user.lastName,
                phoneNumber: user.phoneNumber,
            }
        }
    });

    const [createUser, {error: createUserError}] = useMutation(CREATE_USER, {
        variables: {
            newUser: {
                firstName: user.firstName,
                lastName: user.lastName,
                phoneNumber: user.phoneNumber,
            }
        }
    });

    useEffect(() => {
        if (createUserError) notify('createUserError', 'error', createUserError.message);
        if (getUserError) notify('getUserError', 'error', getUserError.message);
        if (updateUserError) notify('updateUserError', 'error', updateUserError.message);
    }, [createUserError, getUserError, updateUserError]);

    useEffect(() => {
        if (getUserData && getUserData.user) {
            let fetchedUser = {...getUserData.user};
            if (getUserData.user.tagLinks) {
                let tags = [];
                getUserData.user.tagLinks.map((tagLink) => {
                    const tag = {id: tagLink.tagId, text: tagLink.tag.tag};
                    tags.push(tag);
                    return tag;
                });
                fetchedUser.tags = tags;
            }
            setUser({...fetchedUser});
            if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
        }
    }, [getUserData]);

    useEffect(() => {
    }, [user]);

    useEffect(() => {
        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
    }, []);

    const handleChange = (e) => {
        const updatedUser = {
            ...user,
            [e.target.name]: e.target.value
        };
        setUser(updatedUser);
        if (!globalPersistentState.dirty) globalPersistentActions.setDirty(true);
    };

    const validateForm = () => {
        setErrors({});
        let newError = {};
        if (!user.firstName || user.firstName.length === 0) newError.firstName = 'User First Name cannot be empty';
        if (!user.lastName || user.lastName.length === 0) newError.lastName = 'User First Name cannot be empty';

        if (Object.keys(newError).length > 0) {
            setErrors(newError);
            return false;
        } else {
            return true;
        }
    };

    if (getUserLoading) return <p>Loading ...</p>;

    return (
        <form className={classes.root}>
            <AppBar color={props.color ? props.color : 'default'} position="static" className={classes.noMargin}>
                <Toolbar className={classes.noMargin}>
                    <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.title}
                    >
                        {user.displayName ? user.displayName : "New User"}
                    </Typography>
                    <div className={classes.grow}/>
                    <IconButton
                        aria-label="save user"
                        id={"save-user"}
                        color="inherit"
                        size="small"
                        disabled={!globalPersistentState.dirty}
                        onClick={() => {
                            if (validateForm()) {
                                if (user.userId && user.userId !== 'new') {
                                    updateUser().then(async (updateResult) => {
                                        notify('updateUser', 'info', 'User updated');
                                        setUser(user);
                                        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                        history.goBack();
                                        props.parentRefresh();
                                    })
                                } else {
                                    createUser().then(async (createResult) => {
                                        notify('createUser', 'info', 'User created');
                                        if (globalPersistentState.dirty) globalPersistentActions.setDirty(false);
                                        history.goBack();
                                        props.parentRefresh();
                                    })
                                }
                            }
                        }}>
                        <BackupOutlinedIcon/>
                    </IconButton>
                    <IconButton
                        aria-label="cancel edit user"
                        id={"cancel-save-user"}
                        color="inherit"
                        size="small"
                        onClick={() => {
                            history.goBack();
                            props.parentRefresh();
                        }}>
                        <ClearIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>

            {user && (<Grid container className={classes.gridContainer}>
                <Grid item xs={4} className={classes.leftField}>
                    <FormControl
                        className={errors.userName ? classes.formControlError : classes.formControl}
                        margin="dense"
                        size="small"
                        fullWidth
                    >
                        <TextField
                            required
                            id="firstName"
                            name="firstName"
                            label="First name"
                            fullWidth
                            size="small"
                            onChange={handleChange}
                            value={user.firstName}
                        />
                        <FormHelperText>
                            {errors.firstName}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={4} className={classes.middleField}>
                    <FormControl
                        className={classes.formControl}
                        margin="dense"
                        size="small"
                        fullWidth
                    >
                        <TextField
                            required
                            id="lastName"
                            name="lastName"
                            label="Last name"
                            fullWidth
                            size="small"
                            onChange={handleChange}
                            value={user.lastName}
                        />
                        <FormHelperText>
                            {errors.lastName}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                <Grid item xs={4} className={classes.rightField}>
                    <FormControl
                        className={classes.formControl}
                        margin="dense"
                        size="small"
                        fullWidth
                    >
                        <TextField
                            id="phoneNumber"
                            name="phoneNumber"
                            label="Phone Number"
                            fullWidth
                            size="small"
                            onChange={handleChange}
                            value={user.phoneNumber}
                        />
                    </FormControl>
                </Grid>
            </Grid>)}
        </form>
    )
};

export default UserEdit
